<template>
  <div>
    <LayoutHeader
      :title="copy[this.lang].title"
      :lang="lang"
    />

    <v-form ref="form" v-if="!hasSubmitted">
      <v-container class="a-container">
        <v-layout column>
          <LayoutIntro
            :main="copy[this.lang].intro"
            :readMore="copy[this.lang].readMore || null"
          />


          <!-- TOGGLE -->
          <!-- <v&#45;flex v&#45;if="simpleLink" :style="!simpleLink ? 'display:none;' : ''"> -->
          <!--   <v&#45;btn small v&#45;on:click="toggleSimpleLink">Upload footage</v&#45;btn> -->
          <!-- </v&#45;flex> -->
          <LayoutQuestions :questions="copy[this.lang].options" />

          <!-- DETAILS -->
          <LayoutDetails
            :isSimple="!isUpload"
            :placeholders="isUpload ? copy[this.lang].detailsUpload : copy[this.lang].detailsLink"
          />
          <!-- UPLOADER -->
          <span v-if="isUpload">
            <v-flex xs12>
              <h2>{{ copy[this.lang].uploadHeader }}</h2>
            </v-flex>
            <v-flex xs12>
              <p>{{ copy[this.lang].uploadSub }}</p>
            </v-flex>
            <v-flex xs12>
              <Uploader
                :msg="copy[this.lang].uploadText"
              />
            </v-flex>
            <!-- QUESTIONS -->
            <v-flex xs12>
              <LayoutQuestions :questions="copy[this.lang].questions" />
            </v-flex>
            <!-- ADDITIONAL -->
            <v-flex xs12>
              <LayoutAdditional addtype="where" :text="copy[this.lang].where" />
            </v-flex>
            <v-flex xs12>
              <LayoutAdditional addtype="when" :text="copy[this.lang].when" />
            </v-flex>
          </span>
            <!-- TERMS -->
            <v-flex xs12>
              <LayoutTerms :terms="copy[this.lang].terms" />
            </v-flex>

            <v-flex xs12>
              <LayoutAdditional addtype="additional" :text="copy[this.lang].additional" />
            </v-flex>
          <v-layout>
            <!-- <v-btn v-on:click="sendForm" :disabled="false" large block>{{ copy[this.lang].submitText }}</v-btn> -->
            <v-btn @click="dialog = true" v-on:click="sendForm" :disabled="formIsValid" large block>{{ copy[this.lang].submitText }}</v-btn>
            <v-dialog
              v-model="dialog"
              persistent
              width="500"
            >
              <v-card
                color="rgb(0,0,0)"
                dark
              >
                <v-card-text>
                  Sending
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>

          </v-layout>
        </v-layout>
      </v-container>
    </v-form>
    <div v-else>
      <LayoutIntro :main="copy[this.lang].submitted" />
    </div>
    <iframe src="https://player.vimeo.com/video/434620519?title=0&byline=0&portrait=0" class="fullw" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Uploader from './Uploader'
import LayoutHeader from './LayoutHeader'
import LayoutIntro from './LayoutIntro'
import LayoutDetails from './LayoutDetails'
import LayoutQuestions from './LayoutQuestions'
import LayoutTerms from './LayoutTerms'
import LayoutAdditional from './LayoutAdditional'
import { validate } from '../util'

export default {
  name: 'Layout',
  components: {
    LayoutHeader,
    LayoutIntro,
    LayoutDetails,
    Uploader,
    LayoutQuestions,
    LayoutTerms,
    LayoutAdditional
  },
  data () {
    return {
      dialog: false,
      hasSubmitted: false
    }
  },
  methods: {
    sendForm () {
      const me = this
      this.$http.post('/submit', this.form)
        .then(res => {
          this.dialog = false
          window.scrollTo(0,0)
          me.hasSubmitted = true
        })
        .catch(err => {
          // alert('Something went wrong, please try again.')
          // this.dialog = false
          // window.scrollTo(0,0)
          me.hasSubmitted = true
        })
    }
  },
  computed: {
    ...mapState(['lang', 'copy', 'form']),
    isUpload: function () {
      return this.form.submissiontype === 'Upload footage'
    },
    isAuthor: function () {
      return this.form.anon === 'Yes'
    },
    formIsValid: function () {
      return validate(this.form, this.isUpload)
    }
  }
}
</script>

<style scoped>
.a-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 800px;
  margin: auto;
  margin-bottom: 15em;
}

.text {
  max-width: 600px;
}
</style>
